module.exports = __webpack_public_path__ + "static/img/2949_phase_function_Paper_Points.9553a1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2949_phase_function_Paper_Points.png
// module id = TNxA
// module chunks = 0